import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_mst_item_ext_RowClass} from '../../../dbschema/bl_inv_mst_item_ext.model';


export class InventoryItemExtensionContainerModel extends BaseContainerModel {
  bl_inv_mst_item_ext: bl_inv_mst_item_ext_RowClass = new bl_inv_mst_item_ext_RowClass();
}


